import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "./scss/index.scss";
import classNames from "classnames";
import { stringify } from "query-string";
import * as React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
import ReactSVG from "react-svg";
import { commonMessages } from "@temp/intl";
import { Button, Loader, OfflinePlaceholder, Overlay, OverlayType } from "../..";
import { searchUrl } from "../../../app/routes";
import { maybe } from "../../../core/utils";
import { DebouncedTextField } from "../../Debounce";
import { Error } from "../../Error";
import NetworkStatus from "../../NetworkStatus";
import NothingFound from "./NothingFound";
import ProductItem from "./ProductItem";
import { TypedSearchResults } from "./queries";
import searchImg from "../../../images/search.svg";
import closeImg from "../../../images/x.svg";

var Search =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Search)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      search: ""
    }, _this.submitBtnRef = React.createRef(), _this.hasResults = function (data) {
      return maybe(function () {
        return !!data.products.edges.length;
      });
    }, _this.handleSubmit = function (evt) {
      if (_this.hasSearchPhrase && _this.submitBtnRef.current) {
        _this.props.overlay.hide();

        _this.props.history.push("".concat(searchUrl, "?").concat(_this.searchQs));
      }

      evt.preventDefault();
    }, _this.handleInputBlur = function () {
      if (!_this.hasSearchPhrase) {
        _this.props.overlay.hide();
      }
    }, _temp));
  }

  _createClass(Search, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (!!prevState.search.length && this.props.overlay.type !== OverlayType.search) {
        this.setState({
          search: ""
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Overlay, {
        testingContext: "searchOverlay",
        context: this.props.overlay,
        className: "overlay--no-background"
      }, React.createElement("form", {
        className: classNames("search", {
          "search--has-results": this.hasSearchPhrase
        }),
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onSubmit: this.handleSubmit
      }, React.createElement("div", {
        className: "search__input"
      }, React.createElement(DebouncedTextField, {
        onChange: function onChange(evt) {
          return _this2.setState({
            search: evt.target.value
          });
        },
        value: this.state.search,
        iconLeft: React.createElement(ReactSVG, {
          path: closeImg,
          onClick: this.props.overlay.hide,
          className: "search__input__close-btn"
        }),
        iconRight: React.createElement(ReactSVG, {
          path: searchImg
        }),
        autoFocus: true,
        placeholder: this.props.intl.formatMessage(commonMessages.search),
        onBlur: this.handleInputBlur
      })), React.createElement("div", {
        className: classNames({
          search__products: true,
          "search__products--expanded": this.hasSearchPhrase
        })
      }, React.createElement(NetworkStatus, null, function (isOnline) {
        if (_this2.hasSearchPhrase) {
          return React.createElement(TypedSearchResults, {
            renderOnError: true,
            displayError: false,
            errorPolicy: "all",
            variables: {
              query: _this2.state.search
            }
          }, function (_ref) {
            var data = _ref.data,
                error = _ref.error,
                loading = _ref.loading;

            if (_this2.hasResults(data)) {
              return React.createElement(React.Fragment, null, React.createElement("ul", null, data.products.edges.map(function (product) {
                return React.createElement(ProductItem, _extends({}, product, {
                  key: product.node.id
                }));
              })), React.createElement("div", {
                className: "search__products__footer"
              }, loading ? React.createElement(Loader, null) : React.createElement(Button, {
                testingContext: "searchProductsButton",
                btnRef: _this2.submitBtnRef,
                type: "submit"
              }, React.createElement(FormattedMessage, {
                id: "components.OverlayManager.Search.Search.4112727608",
                defaultMessage: "Show all results"
              }))));
            }

            if (error) {
              return isOnline ? React.createElement(Error, {
                error: error.message
              }) : React.createElement(OfflinePlaceholder, null);
            }

            return React.createElement(NothingFound, {
              search: _this2.state.search
            });
          });
        }

        return null;
      }))));
    }
  }, {
    key: "hasSearchPhrase",
    get: function get() {
      return this.state.search.length > 0;
    }
  }, {
    key: "redirectTo",
    get: function get() {
      return {
        pathname: searchUrl,
        search: "?".concat(this.searchQs)
      };
    }
  }, {
    key: "searchQs",
    get: function get() {
      return stringify({
        q: this.state.search
      });
    }
  }]);

  return Search;
}(React.Component); // Workaround ATM for:
// withRouter(Search): Function components do not support contextType


export default injectIntl(withRouter(function (props) {
  return React.createElement(Search, props);
}));